import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Paper, Grid } from '@mui/material'
import { withStyles } from '@mui/styles'
import { style } from 'styles'

function Reservations({ classes }) {
	const navigate = useNavigate()
	const services = useSelector(state => state.services.services)

	const handleServiceSelected = (service_id) => {
		navigate(`/reservations/${service_id}`)
	}

	return (<React.Fragment>
		<div className={classes.homeBackground}></div>

		<Paper elevation={3} className="box">
			<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 60 }}>
				<span style={{ fontSize: 22 }}>Prenotazione</span>
			</div>
		</Paper>

		<div className={classes.page} style={{ width: '91vw' }} >
			<Grid container spacing={1} className={classes.productsList} >
				{services.map((service) => (
					<Grid key={service.item_id} item xs={12} sm={6} md={4} lg={3} xl={2}>
						<div className="product grid" onClick={() => handleServiceSelected(service.item_id)}>
							{service.main_image != null ?
								<div className="pic">
									<img style={{ width: '80%' }} src={`${window.__endpoint}/images/products/m/${service.main_image ? service.main_image.image_id : 'missing'}.jpg`} alt={service.name} />
								</div>
								:
								<div className="pic">
									<div className="title">
										{service.name}
									</div>
								</div>}
						</div>
					</Grid>
				))}
			</Grid>
		</div>
	</React.Fragment>)
}

export default withStyles(style)(Reservations)
